import utils from 'src/utils'
import _ from 'lodash'

export default {
  currentIsSupervisor: (state) => state.current ? state.current.is_franchise_supervisor : false,
  currentIsPasswordManager: (state) => state.current ? state.current.is_password_manager : false,
  currentIsOrganizationAdmin: (state) => state.current ? state.current.is_organization_admin : false,
  currentIsSuperAdmin: (state) => state.current ? state.current.is_super_admin : false,
  currentIsLicencesManager: (state) => state.current ? state.current.is_licences_manager : false,
  currentIsUsersAdmin: (state) => state.current ? state.current.is_users_admin : false,
  currentIsFranchiseAdmin: (state) => state.current ? state.current.is_franchise_admin : false,
  currentIsLoaded: (state) => !!state.current,
  getUsers: (state) => state.users,
  currentIsAdmin (state) {
    return state.current ?
      (state.current.is_franchise_admin || state.current.is_organization_admin || state.current.is_super_admin || state.current.is_users_admin)
      : false
  },
  locationsAsList (state) {
    return state.locations ? utils.getForOptionList(state.locations, 'name', 'id') : []
  },
  userLocations (state) {
    const assignedLocations = state.current ? state.current.roles.map(role => role.location_id) : []
    return _.union(assignedLocations)
  },
  userFranchisesAdmin (state) {
    const franchises = state.current ? state.current.roles.filter(role => role.id === 5).map(role => role.franchise_id) : []
    return _.union(franchises)
  },
  userFranchisesSupervisor (state) {
    const franchises = state.current ? state.current.roles.filter(role => role.id === 401).map(role => role.franchise_id) : []
    return _.union(franchises)
  },
  userUsersAdmin (state) {
    let franchises = state.current ? state.current.roles.filter(role => role.id === 9).map(role => role.franchise_id) : []
    return _.union(franchises)
  },
  currentHas2fa () {
    return true
  },
  getRolesWithHierarchy (state) {
    if (state.currentIsOrganizationAdmin) return state.current.roles.filter(role => role.id === 4)

    const topRoles = state.current ? state.current.roles.filter((role, index, self) =>
      (role.id === 5 || role.id === 401 || role.id === 8 || role.id === 9) && role.franchise_role_id === null && index === self.findIndex((o) =>
        o.id === role.id && o.franchise_id === role.franchise_id)
    ) : []

    const hierarchicalRoles = state.current
      ? state.current.roles.filter((role, index, self) =>
        role.franchise_role_id !== null && role.franchise_role_id === role.franchise_id &&
        index === self.findIndex((o) =>
          o.role_id === role.role_id && o.location_id === role.location_id && o.franchise_id === role.franchise_id)
      )
      : []

    const scopeFranchises = state.currentIsAdmin ? state.userFranchisesAdmin : state.userFranchisesSupervisor
    const franchiseScopedRoles = state.current && (state.currentIsAdmin || state.currentIsSupervisor)
      ? state.current.roles.filter(role => scopeFranchises.some(id => id !== role.franchise_id))
      : []

    return [...topRoles, ...hierarchicalRoles, ...franchiseScopedRoles].filter((role, index, self) =>
      index === self.findIndex((o) =>
        o.id === role.id && o.location_id === role.location_id && o.franchise_id === role.franchise_id))
  },
  userHierarchies (state) {
    if (state.currentIsOrganizationAdmin) return []
    const roles = state.getRolesWithHierarchy
    return roles.filter((role, index, self) => index === self.findIndex((o) => o.franchise_id === role.franchise_id))
      .map(fran => fran.franchise_id)
  },
  isAvailableRole (state) {
    return (state.currentIsOrganizationAdmin && state.current?.organization?.id)
      || (state.currentIsSupervisor || state.currentIsAdmin || state.currentIsUsersAdmin)
  },
  // TKT-2283: el Reporte de Asistencia se acota en dos niveles, ambos configurables sin release:
  // la organizacion debe tenerlo en `available_reports` (toggle del admin) y, si existe la lista
  // `attendance_report_users`, el usuario debe estar en ella (Lamosa lo pidio solo para un set de
  // usuarios). Lista ausente/vacia = todos los de la organizacion. Mismo criterio en el backend
  // (App\Services\Reports\Attendance\AttendanceReportAccess), que ademas responde 403.
  hasAttendanceReportAccess (state) {
    const organization = state.current?.organization
    if (!organization) return false

    const availableReports = Array.isArray(organization.available_reports) ? organization.available_reports : []
    if (!availableReports.includes('attendance')) return false

    // Falla cerrado si el payload no trae la llave: solo users/user (graphql) la manda, siempre
    // (`[]` cuando no hay lista). El currentUser del login legacy trae available_reports pero NO
    // la lista, y tomarlo como "lista vacia" le mostraba el reporte a toda la organizacion.
    if (!Array.isArray(organization.attendance_report_users)) return false

    const allowedUsers = organization.attendance_report_users.map(Number).filter(id => !Number.isNaN(id))
    if (!allowedUsers.length) return true

    return allowedUsers.includes(Number(state.current?.id))
  },
  hasMermaHarvestAccess (state) {
    return state.current?.organization?.id === 126 ||
      (state.current?.id === 8773 && state.current?.organization?.id === 86)
  }
}
